// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rdwR","index":"styles_index__2UUnU"};